var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58333 5.625C6.32917 5.625 6.08541 5.72597 5.90569 5.90569C5.72597 6.08541 5.625 6.32917 5.625 6.58333C5.625 6.8375 5.72597 7.08125 5.90569 7.26098C6.08541 7.4407 6.32917 7.54167 6.58333 7.54167C6.8375 7.54167 7.08125 7.4407 7.26098 7.26098C7.4407 7.08125 7.54167 6.8375 7.54167 6.58333C7.54167 6.32917 7.4407 6.08541 7.26098 5.90569C7.08125 5.72597 6.8375 5.625 6.58333 5.625Z",
    fill: "#090909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09261 0.833008H9.17826C9.51213 0.833302 9.83222 0.96617 10.0682 1.2024L18.6734 9.8076C18.9092 10.0437 19.0416 10.3638 19.0416 10.6975C19.0416 11.0312 18.9092 11.3513 18.6734 11.5874L11.5877 18.6731C11.3516 18.9089 11.0315 19.0413 10.6978 19.0413C10.3641 19.0413 10.044 18.9089 9.80791 18.6731L1.20271 10.0679C0.966475 9.83192 0.833607 9.51183 0.833313 9.17795V2.09231C0.833313 1.75832 0.965989 1.43801 1.20215 1.20185C1.43832 0.965683 1.75862 0.833008 2.09261 0.833008ZM2.09261 2.09231V9.17795L10.6978 17.7832L17.7835 10.6975L9.17826 2.09231H2.09261Z",
    fill: "#090909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.47dc2af35f568fa4bebd3e571b5e078e.svg";
export { ForwardRef as ReactComponent };